import { EnergyType } from '@energy-retailer/constants';

import type { PlanSchema } from '@energy-retailer/schema';

export const formatAnnualConsumption = (
  value: PlanSchema['annualConsumption'],
  energyType: EnergyType
): string => {
  switch (energyType) {
    case EnergyType.Electricity:
      return `${value}kWh`;
    case EnergyType.Gas: {
      const annualConsumption = new Intl.NumberFormat('en-AU', {
        maximumSignificantDigits: 3,
      });

      const formattedValue = annualConsumption.format(value / 1000);

      return `${formattedValue}Gj`;
    }
  }
};
